export default {"src":"/_next/static/media/machinery-manufacturing-firm.5cc17738.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};